export default "__VITE_ASSET__nMGFKCAb$q6PyYtU4pEbBQ__"